import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { SprossentypePage } from '../sprossentype/sprossentype';
import { RahmenPage } from '../rahmen/rahmen';
import { QuickviewPage } from '../quickview/quickview';


@Component({
  selector: 'page-sprossen',
  templateUrl: 'sprossen.html',
})
export class SprossenPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
outColorIn: string;
outColorOut: string;
selectedGriffe: string;
selectedOrnament: any; 
selectedVerglasung: any; 
selectedKante: string;
verglasung_cat: any;
glas: any; 
kante: any;
requiredSprossen: boolean;
selectedSprossentyp: any;
selectedSprossenmuster: any;
selectedSprossenfarbe: any;
sprossen_cat: any;


  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public popoverCtrl: PopoverController  )  {
  
    this.selectedOrnament = this.navParams.get('selectedOrnament');
    this.selectedVerglasung = this.navParams.get('selectedVerglasung');
    this.selectedKante = this.navParams.get('selectedKante');
    this.selectedGriffe = this.navParams.get('selectedGriffe');
    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.dichtungen, this.outColorIn, this.outColorOut, this.selectedGriffe, this.selectedKante, this.selectedVerglasung, this.selectedOrnament); 
  }

    presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen, windowlong: this.windowlong, windowwide: this.windowwide, outColorIn:this.outColorIn, outColorOut:this.outColorOut, dichtungen: this.dichtungen, selectedGriffe:this.selectedGriffe, selectedKante:this.selectedKante, selectedVerglasung:this.selectedVerglasung, selectedOrnament:this.selectedOrnament}
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad SprossenPage');
  }
  
   requiredtoSprossen(sprossen) {
   this.requiredSprossen = sprossen;
   console.log(this.requiredSprossen); 
   }
   
       presentModalSprossen(sprossen_cat) {
    let sprossenModal = this.modalCtrl.create(SprossentypePage, {
      'selectedSprossentyp': this.selectedSprossentyp,
      'selectedSprossenfarbe': this.selectedSprossenfarbe,
      'selectedSprossenmuster': this.selectedSprossenmuster,
       sprossen_cat: sprossen_cat,
    });
    sprossenModal.onDidDismiss(data => {
      this.selectedSprossentyp = data.sprossen1;
      this.selectedSprossenfarbe = data.sprossen2;
      this.selectedSprossenmuster = data.sprossen3;
      //this.griffe_img = data.griffe_img;
    });
    sprossenModal.present();
  }
  
      clicksprossen(selectedSprossentyp, selectedSprossenfarbe, selectedSprossenmuster) {
    this.navCtrl.push(RahmenPage, { 
    selectedSprossentyp: selectedSprossentyp,
    selectedSprossenfarbe: selectedSprossenfarbe,
    selectedSprossenmuster: selectedSprossenmuster,
    selectedVerglasung: this.selectedVerglasung,
    selectedKante: this.selectedKante,
    selectedOrnament: this.selectedOrnament,
    selectedGriffe: this.selectedGriffe,
    dichtungen: this.dichtungen,
    outColorIn: this.outColorIn,
    outColorOut: this.outColorOut,
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/sprossen/sprossen.ts